module.exports = __webpack_public_path__ + "img/ribbon-silver.fb00fd3e.svg";